module.exports = __webpack_public_path__ + "static/media/vitória-es.6768d287.jpg";